
import { getVLPJson,putApiVLP,postApiVLP,getJson } from "./networkService";

export async function GetUserRoutes() {
  try {
    let response = await getVLPJson(`vlp/user-routes`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetWaterProfilesByAccount(accountNumber) {
  try {
    let response = await getVLPJson(`api/vlp/client-water-profiles/account-number/${accountNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetWaterProfileById(profileId) {
  try {
    let response = await getVLPJson(`api/vlp/client-water-profiles/${profileId}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetOrderByNumber(orderNumber,accountNumber) {
  try {
    let response = await  getJson(`/orders/${orderNumber}/client/${accountNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetDropDownOrders(accountNumber) {
  try {
    let response = await  getJson(`/orders/account/${accountNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetWaterProfileOrders(orderNumbers) {
  try {
    let response = await  getJson(`/orders/water-profile-orders/${orderNumbers}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetNextTypeForClient(accountNumber) {
  try {
    let response = await getVLPJson(`api/vlp/client-water-profiles/next-type/${accountNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function UpdateWaterProfile(route) {  
  try {
    let response = await putApiVLP("api/vlp/client-water-profiles",  route );
    return response;
  } catch (error) {
    throw error;
  }
}




export async function SaveWaterProfile(route) {
  try {
    let response = await postApiVLP("api/vlp/client-water-profiles",  route );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CheckTypeAvailability(route) {
  try {
    let response = await postApiVLP("api/vlp/client-water-profiles/name-availability",  route );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteWaterProfile(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await getVLPJson(`vlp/client-water-profiles/${encodedUrl}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function AlterActiveState(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await getVLPJson(`vlp/client-water-profiles/${encodedUrl}`)
      ;
    return response;
  } catch (error) {
    throw error;
  }
}


export async function DuplicateWaterProfile(routeId,selectedRoute) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await getVLPJson(`vlp/client-water-profiles/${encodedUrl}/duplicate`, { json: selectedRoute })
      ;
    return response;
  } catch (error) {
    throw error;
  }
}
